(function ($) {
  $(function () {
    let firstText = $(
      " .tab-with-map .tabs-items ul li:first-child span"
    ).text();
    $(".tab-with-map .tabs-items .mobile-visible").text(firstText);
    $(".tab-with-map .tabs-items .mobile-visible").on("click", function (e) {
      e.stopPropagation();
      $(this).siblings("ul").slideToggle();
      $(this).toggleClass("active");
    });

    $(document).click(function (e) {
      {
        $(".tab-with-map .tabs-items ul").slideUp();
      }
    });

    var $tabs = $(".tab-with-map .tabs-items ul li span");

    // Add data-tab to each li (from span text)
    $tabs.each(function () {
      var text = $(this).text().trim().replace(/\s+/g, "");
      $(this).closest("li").attr("data-tab", text);
    });

    // Hide all tab content except first
    // $(".tab-with-map.tab-with-map .tab-content").hide().first().show();
    $(".tab-with-map .tabs-items ul li.chicago").addClass("active");
    $(".tab-with-map.tab-with-map .tab-content").hide().eq(1).show();

    $(".tab-with-map .tabs-items ul li.chicago").click();
    // On tab click
    $(".tab-with-map .tabs-items ul li").on("click", function () {
      var tabId = $(this).data("tab");

      let tabText = $(this).find("span").text();
      //On li click → update mobile-visible
      $(".tab-with-map .tabs-items .mobile-visible").text(tabText);
      // $(".tab-with-map .tabs-items ul").stop(true, true).slideUp()
      // Update active tab
      $(".tab-with-map .tabs-items ul li").removeClass("active");
      $(this).addClass("active");

      // Show matching content
      $(".tab-with-map .tab-content").hide();
      $('.tab-with-map .tab-content[data-tab="' + tabId + '"]').show();
    });
    $(window).on("resize", function () {
      if ($(window).width() >= 1024) {
        $(".tab-with-map .tabs-items .mobile-visible").removeClass("active");
        $(".tab-with-map .tabs-items ul ").removeAttr("style");
      } else {
        $(".tab-with-map .tabs-items ul li").on("click", function () {
          $(this).parents("ul").slideUp();

          $(".tab-with-map .tabs-items .mobile-visible").removeClass("active");
        });
      }
    });

    $(window).on("load", function () {
      $(".tab-with-map .tabs-body-wrapper").addClass("active");
      $(".tab-with-map .tabs-items").addClass("active");
    });
  });
})(jQuery);

// document.addEventListener("DOMContentLoaded", () => {
//   var section = document.querySelector(".tab-with-map ");
//   if (section) {
//     const counters = document.querySelectorAll(".tab-with-map .count-wrap ");

//     // Animate all counters so they finish at the same time
//     const runCounters = (duration = 4000) => {
//       const startTime = performance.now();
//       const targets = Array.from(counters).map((counter) => ({
//         el: counter,
//         target: parseInt(counter.getAttribute("data-target"), 10) || 0,
//         suffix: counter.getAttribute("data-suffix") || "",
//       }));

//       // Initialize display
//       targets.forEach(({ el, suffix }) => {
//         el.textContent = "0" + suffix;
//       });

//       const tick = (now) => {
//         const elapsed = now - startTime;
//         const progress = Math.min(elapsed / duration, 1);

//         targets.forEach(({ el, target, suffix }) => {
//           const value = progress < 1 ? Math.floor(target * progress) : target;
//           el.textContent = value + suffix;
//         });

//         if (progress < 1) {
//           requestAnimationFrame(tick);
//         }
//       };

//       requestAnimationFrame(tick);
//     };

//     // Function to check if section is visible
//     const isInViewport = (element) => {
//       const rect = element.getBoundingClientRect();
//       return rect.top < window.innerHeight && rect.bottom > 0;
//     };

//     let hasRun = false;

//     if (section && isInViewport(section)) {
//       //  Section already visible → run immediately
//       runCounters();
//       hasRun = true;
//     } else {
//       //  Wait until section comes into view → run once
//       const observer = new IntersectionObserver(
//         (entries, obs) => {
//           entries.forEach((entry) => {
//             if (entry.isIntersecting && !hasRun) {
//               runCounters();
//               hasRun = true;
//               obs.disconnect(); // stop observing after first run
//             }
//           });
//         },
//         { threshold: 0.5 }
//       );

//       observer.observe(section);
//     }
//   }
// });

document.addEventListener("DOMContentLoaded", () => {
  var section = document.querySelector(".tab-with-map");
  const duration = 3000; // milliseconds - all counters finish together

  // Animate counters in a given context (defaults to all if not provided)
  function runCounters(context) {
    const counters = (context || document).querySelectorAll(".count-wrap");
    counters.forEach((counter) => {
      // Check if parent .tab-content has .stop-counter class
      var parentTab = counter.closest('.tab-content');
      const prefix = counter.getAttribute("data-prefix") || "";
      if (parentTab && parentTab.classList.contains('stop-counter')) {
        // Do not animate, just set to target value immediately
        const target = +counter.getAttribute("data-target");
        const suffix = counter.getAttribute("data-suffix") || "";
        counter.textContent = prefix + target + suffix;
        return;
      }
      // Animate as usual
      const suffix = counter.getAttribute("data-suffix") || "";
      counter.textContent = prefix + "0" + suffix;
    });

    const startTime = performance.now();

    const animate = () => {
      const now = performance.now();
      const elapsed = now - startTime;
      const progress = Math.min(elapsed / duration, 1);

      counters.forEach((counter) => {
        var parentTab = counter.closest('.tab-content');
        const prefix = counter.getAttribute("data-prefix") || "";
        if (parentTab && parentTab.classList.contains('stop-counter')) {
          // Already set, skip animation
          return;
        }
        const target = +counter.getAttribute("data-target");
        const suffix = counter.getAttribute("data-suffix") || "";
        const value = Math.floor(target * progress);
        counter.textContent = prefix + value + suffix;
      });

      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        // Ensure final values are exact
        counters.forEach((counter) => {
          var parentTab = counter.closest('.tab-content');
          const prefix = counter.getAttribute("data-prefix") || "";
          if (parentTab && parentTab.classList.contains('stop-counter')) {
            return;
          }
          const target = +counter.getAttribute("data-target");
          const suffix = counter.getAttribute("data-suffix") || "";
          counter.textContent = prefix + target + suffix;
        });
      }
    };

    requestAnimationFrame(animate);
  }

  // Function to check if section is visible
  const isInViewport = (element) => {
    const rect = element.getBoundingClientRect();
    return rect.top < window.innerHeight && rect.bottom > 0;
  };

  let hasRun = false;

  if (section && isInViewport(section)) {
    //  Section already visible → run immediately
    runCounters(section);
    hasRun = true;
  } else if (section) {
    //  Wait until section comes into view → run once
    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !hasRun) {
            runCounters(section);
            hasRun = true;
            obs.disconnect(); // stop observing after first run
          }
        });
      }, {
        // Trigger earlier on short viewports and when sticky headers are present
        threshold: 0.1,
        rootMargin: "0px 0px -150px 0px",
      }
    );

    observer.observe(section);
  }

  // Reset and animate counters on tab click
  document.querySelectorAll('.tab-with-map .tabs-items ul li').forEach(function (tab) {
    tab.addEventListener('click', function () {
      // Find the visible tab-content
      setTimeout(function () {
        var visibleTab = document.querySelector('.tab-with-map .tab-content:not([style*="display: none"])');
        if (visibleTab) {
          runCounters(visibleTab);
        }
      }, 10); // Wait for tab to show
    });
  });
});